import { INPUT_PHRASES, OUTPUT_PHRASES, UNRECOGNIZED_PHRASES } from '../../const/logFilters';
import logLevels from '../../const/logLevels';
import isLocalStorageAvailable from '../../services/mini/isLocalStorageAvailable';
import * as _ from 'lodash';
import { ILog } from '../../models/ILog';

const maxLogsCount = 300;
let currentLogs = [];
let readLogIds = {};
let isLoading = true;

function getLastXLogItems(logItems) {
    if (logItems.length > maxLogsCount) {
        return logItems.slice(logItems.length - maxLogsCount, logItems.length);
    }
    return logItems;
}

const projectLogsKeeper = {

    logInTooltip: {},

    addLogs: (logs) => {
        currentLogs = [...currentLogs, ...logs];

        const errorLogs = getLastXLogItems(currentLogs.filter(log => log.level === logLevels.runTimeError));
        const infoLogs = getLastXLogItems(currentLogs.filter(log => log.level === logLevels.info));
        const inputPhrases = getLastXLogItems(currentLogs.filter(log => log.type === 'INPUT'));
        const outputPhrases = getLastXLogItems(currentLogs.filter(log => log.type === 'OUTPUT'));

        currentLogs = [...errorLogs, ...infoLogs, ...inputPhrases, ...outputPhrases];
        currentLogs = _.uniqBy(currentLogs, 'id');
        currentLogs = _.sortBy(currentLogs, 'ts');

        for (let i = 0; i < currentLogs.length; i++) {
            if (readLogIds[currentLogs[i].id]) {
                currentLogs[i].new = false;
            }
        }
        isLoading = false;
    },

    getLogs: () => {
        return currentLogs;
    },

    clear: () => {
        readLogIds = {};
        currentLogs = [];
    },

    getLogKey: (projectId, environment) => {
        return `alan-read-log-${environment}-${projectId}`;
    },

    getNewFlag: (projectId, environment, log: ILog) => {
        const key = projectLogsKeeper.getLogKey(projectId, environment);
        if (isLocalStorageAvailable()) {
            const savedTs = +localStorage.getItem(key);

            if (savedTs && savedTs >= +log.ts) {
                return false;
            }
        }
        return true;
    },

    saveLogReadInfo: (projectId, environment, log: ILog) => {
        const key = projectLogsKeeper.getLogKey(projectId, environment);

        if (isLocalStorageAvailable()) {
            const savedTs = +localStorage.getItem(key);
            if (!savedTs || (savedTs <= +log.ts)) {
                localStorage.setItem(key, log.ts.toString());
            }
        }
    },

    markAsSeen: (projectId: string, environment: string, log: ILog, filters) => {
        if (log) {
            let firstReadLogInd = null;
            let lastReadLogInd = null;
            for (let i = 0; i < currentLogs.length; i++) {
                const curLog = currentLogs[i];
                if (currentLogs[i].new === false && firstReadLogInd === null) {
                    firstReadLogInd = i;
                }
                if (curLog.id === log.id) {
                    currentLogs[i].new = false;
                    projectLogsKeeper.saveLogReadInfo(projectId, environment, currentLogs[i]);
                    readLogIds[curLog.id] = true;
                    if (firstReadLogInd !== null) {
                        for (let j = firstReadLogInd; j < i; j++) {
                            currentLogs[j].new = false;
                            projectLogsKeeper.saveLogReadInfo(projectId, environment, currentLogs[j]);
                        }
                    }

                    for (let j = i + 1; j < currentLogs.length; j++) {
                        if (currentLogs[j].new === false && lastReadLogInd === null) {
                            lastReadLogInd = j;
                        }
                    }
                    if (lastReadLogInd !== null) {
                        for (let j = i + 1; j < lastReadLogInd; j++) {
                            currentLogs[j].new = false;
                            projectLogsKeeper.saveLogReadInfo(projectId, environment, currentLogs[j]);
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i < currentLogs.length; i++) {
                const curLog = currentLogs[i];
                if (curLog.level === filters.logLevel) {
                    if (filters.logLevel === logLevels.phrase) {
                        if (curLog.type === 'INPUT' && filters.logFilterType === INPUT_PHRASES) {
                            currentLogs[i].new = false;
                            readLogIds[curLog.id] = true;
                            projectLogsKeeper.saveLogReadInfo(projectId, environment, currentLogs[i]);
                        } else if (curLog.type === 'OUTPUT' && filters.logFilterType === OUTPUT_PHRASES) {
                            currentLogs[i].new = false;
                            readLogIds[curLog.id] = true;
                            projectLogsKeeper.saveLogReadInfo(projectId, environment, currentLogs[i]);
                        } else if ((curLog.type === 'INPUT' || curLog.type === 'OUTPUT') && curLog.notFound && filters.logFilterType === UNRECOGNIZED_PHRASES) {
                            currentLogs[i].new = false;
                            readLogIds[curLog.id] = true;
                        }
                    } else if (filters.logLevel === logLevels.info) {
                        currentLogs[i].new = false;
                        readLogIds[curLog.id] = true;
                        projectLogsKeeper.saveLogReadInfo(projectId, environment, currentLogs[i]);
                    }
                }
            }
        }
    }
};
if (!window.alanDebug) {
    window.alanDebug = {};
    window.alanDebug.projectLogsKeeper = projectLogsKeeper;
}

export default projectLogsKeeper;